import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { PaymentData } from '../../../models/PaymentData';
import { CreditCard } from '../../../models/CreditCard';
import { Sepa } from '../../../models/Sepa';
import { Discount, Option, Subscription } from '@co-assist/library';
/**
 * Last page of the subscription flow
 */
@Component({
    selector: 'app-proceed-payment',
    templateUrl: './proceed-payment.component.html',
    styleUrls: ['./proceed-payment.component.scss']
})
export class ProceedPaymentComponent implements OnInit {
    @Output() previousPage: EventEmitter<{ section, direction }> = new EventEmitter<{ section, direction }>();
    @Output() proceedPayment: EventEmitter<PaymentData> = new EventEmitter<PaymentData>();
    @Output() applyDiscountCode: EventEmitter<Discount> = new EventEmitter<Discount>();
    @Input() subscription: Subscription;
    @Input() equipmentOptions: Option[] = [];
    currentPaymentData: PaymentData;
    discount: Discount;
    creditCard: boolean = true;
    @Output() childChanged = new EventEmitter<number>();
    @Input() registerValue: any;
    registerInfo: any;
    @Output() registerUserId = new EventEmitter<string>();
    @Output() taxCreditChange = new EventEmitter<boolean>();
    @Output() additionalInfoChange = new EventEmitter<string>();
    // isLoading: WritableSignal<boolean> = signal(false);
    paymentSession: string;
    paymentRadio = new UntypedFormControl();
    loadAPI: Promise<any>;
    data: any;
    form: UntypedFormGroup;
    initPayment: boolean = false;
    price: number = 25;
    errorMessageCode: string;
    paymentValidate: boolean = false;
    touched: boolean = false;
    constructor(
        private fb: UntypedFormBuilder
    ) {
    }

    ngOnInit() {
        this.price = this.subscription.getTotalPrice(this.discount);
        if (this.subscription.alreadyOwnWatch) {
            this.equipmentOptions = this.equipmentOptions.filter(eo => eo.name === 'FEE');
        }
        this.form = this.fb.group({
            additionalInfo: new UntypedFormControl(null),
            checkBoxes: this.fb.group({
                generalConditions: new UntypedFormControl(false, Validators.requiredTrue),
                debit: new UntypedFormControl(false, Validators.requiredTrue),
                consent: new UntypedFormControl(false, Validators.requiredTrue),
                taxCredit: new UntypedFormControl(true, Validators.requiredTrue)
            })
        });
    }

    /**
     * Retrieve payment data from PaymentFormComponent each time as an update is made
     */
    getPaymentData(data: CreditCard | Sepa): void {
        if (data !== null) {
            const result = {
                paymentMethod: data.getPaymentMethodName(),
                data: data
            };
            this.currentPaymentData = new PaymentData(result);
        } else {
            this.currentPaymentData = null;
        }
    }
    /**
     * Retrieve payment data from PaymentFormComponent each time as an update is made
     */
    getDiscountData(data: Discount): void {
        if (data !== null) {
            this.discount = data;
        } else {
            this.discount = undefined;
        }
        this.applyDiscountCode.emit(this.discount);
    }

    isValid(formControlName: string): boolean {
        return this.form && this.form.get(formControlName).valid;
    }

    previous(): void {
        this.previousPage.emit({ section: 'payment', direction: 'back' });
    }

    submitPayment(): void {
        this.form.markAllAsTouched();
        this.touched = true; // TODO: find a way to implement ControlValueAccessor and fire mat-error on submit
        if (this.form.valid && this.currentPaymentData && this.currentPaymentData.validatePaymentData()) {
            this.taxCreditChange.emit(true);
            this.additionalInfoChange.emit(this.form.value.additionalInfo);
            this.proceedPayment.emit(this.currentPaymentData);
        }

    }
}
